var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlansAndPermits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:#222A2D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.91,21.92v19.39c0,2.44-1.98,4.42-4.42,4.42H7.99c-2.44,0-4.42-1.98-4.42-4.42V21.92 c0-2.37,1.92-4.29,4.29-4.29h26.76C36.99,17.63,38.91,19.55,38.91,21.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.82,41.14C3.82,41.14,3.82,41.14,3.82,41.14l0,1.05c0,1.85,1.5,3.35,3.35,3.35h1.71v-7.36 c-0.55-0.4-1.21-0.6-1.85-0.6C5.49,37.58,3.82,38.69,3.82,41.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.87,13.99c-2.01,0-3.64,1.64-3.64,3.64c0,2.01,1.63,3.64,3.64,3.64s3.64-1.63,3.64-3.64 C35.51,15.63,33.88,13.99,31.87,13.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.57,28.57c0.07-0.03,0.13-0.05,0.2-0.07c0.19-0.07,0.37-0.13,0.56-0.17c0.07-0.02,0.13-0.03,0.2-0.04 c0.08-0.02,0.17-0.03,0.25-0.04v-9.28c0-0.28,0.22-0.5,0.5-0.5s0.5,0.22,0.5,0.5v9.28c0.08,0.01,0.15,0.02,0.23,0.03 c0.06,0.01,0.13,0.03,0.19,0.04c0.19,0.04,0.37,0.1,0.56,0.16c0.07,0.03,0.14,0.05,0.21,0.08c0.22,0.09,0.44,0.2,0.66,0.33 c0.02,0.01,0.04,0.02,0.07,0.03c0.01,0,0.01,0.01,0.02,0.01V12.98h-4.87v15.95C15.08,28.79,15.33,28.67,15.57,28.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.2,29.35c-1.67,0-3.01,1.35-3.01,3.01c0,1.67,1.34,3.02,3.01,3.02c1.66,0,3.01-1.35,3.01-3.02 C45.21,30.7,43.86,29.35,42.2,29.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.17,45.55c-1.85,0-3.35-1.5-3.35-3.35v-1.05c0,0.27-0.22,0.5-0.5,0.5c-0.28,0-0.5-0.22-0.5-0.5V21.48 c0,0,0,0.01,0,0.01v20.7c0,2.4,1.95,4.35,4.35,4.35h1.71v-1H7.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.36,42.19c0-0.28-0.22-0.5-0.5-0.5s-0.5,0.22-0.5,0.5c0,1.85-1.5,3.35-3.35,3.35H8.88v1h26.12 C37.41,46.55,39.36,44.59,39.36,42.19z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.24,
    y: 17.14,
    className: "st1",
    width: 2.6,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.17,18.14c-1.85,0-3.35,1.5-3.35,3.34v16.6c0.81-1,2.01-1.51,3.21-1.51c0.64,0,1.27,0.16,1.85,0.44V18.14 H7.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.17,17.14h1.71v-4.43c-0.55-0.4-1.21-0.6-1.85-0.6c-1.55,0-3.21,1.11-3.21,3.56v3.09 C4.62,17.77,5.82,17.14,7.17,17.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.24,18.14H8.88v18.89c0.51,0.25,0.98,0.6,1.36,1.06V18.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.24,17.14v-1.48c0-1.43-0.58-2.39-1.36-2.96v4.43H10.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.17,18.14h1.71v-1H7.17c-1.36,0-2.55,0.64-3.35,1.61v2.73C3.83,19.64,5.33,18.14,7.17,18.14z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.88,
    y: 17.14,
    className: "st1",
    width: 1.36,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.82,39.02v2.13c0,0,0,0,0,0c0-2.45,1.66-3.56,3.21-3.56c0.64,0,1.3,0.2,1.85,0.6v-0.6 C7.19,36.6,4.83,37.09,3.82,39.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.32,15.66c0-3.65,3.36-4.83,5.56-3.56v-0.55C8.3,11.26,7.67,11.1,7.03,11.1c-2.09,0-4.21,1.57-4.21,4.56 v5.82c0-0.71,0.19-1.38,0.5-1.97V15.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.74,41.14c0-1.77-0.79-2.94-1.86-3.56v0.6c0.78,0.56,1.36,1.53,1.36,2.96c0,0.28,0.22,0.5,0.5,0.5 s0.5-0.22,0.5-0.5v-23h-0.5V41.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.74,15.66v1.48h0.5v-1.48c0-2.08-1.03-3.45-2.36-4.11v0.55C9.95,12.72,10.74,13.9,10.74,15.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.32,41.64c0.27,0,0.5-0.22,0.5-0.5v-2.13c-0.3,0.58-0.5,1.28-0.5,2.12V19.51c-0.31,0.6-0.5,1.26-0.5,1.97 v19.66C2.82,41.42,3.05,41.64,3.32,41.64z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.74,
    y: 17.14,
    className: "st1",
    width: 0.5,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.82,15.66c0-2.45,1.66-3.56,3.21-3.56c0.64,0,1.3,0.2,1.85,0.6v-0.6c-2.2-1.27-5.56-0.09-5.56,3.56v3.85 c0.14-0.27,0.31-0.52,0.5-0.76V15.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.88,37.58v-0.56c-0.58-0.29-1.22-0.44-1.85-0.44c-1.19,0-2.4,0.51-3.21,1.51v-16.6c0,0,0,0.01,0,0.01v17.53 C4.83,37.09,7.19,36.6,8.88,37.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.24,38.08c-0.38-0.46-0.85-0.81-1.36-1.06v0.56c1.06,0.61,1.86,1.79,1.86,3.56v-23h-0.5V38.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.24,15.66v1.48h0.5v-1.48c0-1.77-0.79-2.94-1.86-3.56v0.6C9.66,13.27,10.24,14.23,10.24,15.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.82,21.48v-2.73c-0.19,0.23-0.36,0.49-0.5,0.76v21.63c0-0.84,0.2-1.54,0.5-2.12L3.82,21.48 C3.82,21.49,3.82,21.48,3.82,21.48z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.24,
    y: 17.14,
    className: "st1",
    width: 0.5,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.88,24.55c0.95-0.95,0.96-0.95,1.9-1.9l-0.59-1.25c0.32-0.78,0.49-1.18,0.81-1.96l1.31-0.46v-2.69L39,15.83 c-0.32-0.79-0.49-1.18-0.81-1.96l0.59-1.25c-0.94-0.95-0.95-0.95-1.9-1.9l-1.25,0.59c-0.78-0.32-1.17-0.49-1.95-0.81l-0.47-1.3 c-1.34,0-1.34,0-2.69,0l-0.46,1.3c-0.78,0.32-1.18,0.49-1.96,0.81l-1.25-0.59c-0.95,0.95-0.95,0.95-1.9,1.9l0.6,1.25 c-0.33,0.78-0.49,1.17-0.82,1.96l-1.3,0.46v2.69l1.3,0.46c0.33,0.78,0.49,1.18,0.82,1.96l-0.6,1.25c0.95,0.95,0.95,0.95,1.9,1.9 l1.25-0.59c0.78,0.32,1.18,0.48,1.96,0.81l0.46,1.3c1.35,0,1.35,0,2.69,0l0.47-1.3c0.78-0.33,1.17-0.49,1.95-0.81L36.88,24.55z  M31.87,21.27c-2.01,0-3.64-1.63-3.64-3.64c0-2,1.63-3.64,3.64-3.64s3.64,1.64,3.64,3.64C35.51,19.64,33.88,21.27,31.87,21.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.43,29.25l0.49-1.03c-0.78-0.79-0.79-0.79-1.57-1.58l-1.04,0.49c-0.64-0.26-0.97-0.4-1.62-0.67l-0.38-1.08 c-1.11,0-1.11,0-2.22,0l-0.39,1.08c-0.64,0.27-0.97,0.41-1.62,0.67l-1.03-0.49c-0.79,0.79-0.79,0.79-1.57,1.58l0.49,1.03 c-0.27,0.65-0.4,0.97-0.67,1.62l-1.08,0.38v2.23l1.08,0.38c0.27,0.65,0.4,0.97,0.67,1.62l-0.49,1.03c0.78,0.79,0.78,0.79,1.57,1.58 l1.03-0.49c0.65,0.26,0.98,0.4,1.62,0.67l0.39,1.08c1.11,0,1.11,0,2.22,0l0.38-1.08c0.65-0.27,0.98-0.41,1.62-0.67l1.04,0.49 c0.78-0.79,0.79-0.79,1.57-1.58l-0.49-1.03c0.27-0.65,0.4-0.97,0.67-1.62l1.08-0.38v-2.23l-1.08-0.38 C47.83,30.22,47.7,29.9,47.43,29.25z M42.2,35.38c-1.67,0-3.01-1.35-3.01-3.02c0-1.66,1.34-3.01,3.01-3.01 c1.66,0,3.01,1.35,3.01,3.01C45.21,34.03,43.86,35.38,42.2,35.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.71,8.9c0-0.66-0.25-1.28-0.71-1.74c-0.46-0.46-1.08-0.71-1.73-0.71c-1.34,0-2.43,1.1-2.43,2.45v3.08h4.87 V8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.34,11.98V8.9c0-1.63,1.32-2.95,2.93-2.95c0.81,0,1.55,0.33,2.09,0.86c0.53,0.54,0.85,1.28,0.85,2.09v3.08 c0.28,0,0.5,0.22,0.5,0.5V8.9c0-0.92-0.35-1.79-1-2.45c-0.66-0.65-1.53-1-2.44-1c-1.89,0-3.43,1.55-3.43,3.45v3.58 C13.84,12.21,14.06,11.98,14.34,11.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.36,6.81c-0.54-0.53-1.28-0.86-2.09-0.86c-1.61,0-2.93,1.32-2.93,2.95v3.08h0.5V8.9 c0-1.35,1.09-2.45,2.43-2.45c0.65,0,1.27,0.25,1.73,0.71c0.46,0.46,0.71,1.08,0.71,1.74v3.08h0.5V8.9 C20.21,8.09,19.89,7.35,19.36,6.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.33,28.32c-0.19,0.04-0.37,0.1-0.56,0.17C15.96,28.42,16.14,28.37,16.33,28.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.78,28.25c0.08,0.01,0.15,0.01,0.23,0.02c-0.08-0.01-0.15-0.03-0.23-0.03V28.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.57,28.57c-0.24,0.1-0.49,0.22-0.73,0.37v-10.8h-1V29.9c0-0.17,0.08-0.31,0.21-0.41 C14.55,29.09,15.06,28.78,15.57,28.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.62,28.89c-0.22-0.13-0.44-0.24-0.66-0.33C19.18,28.65,19.4,28.76,19.62,28.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.53,28.28c0.08-0.02,0.17-0.02,0.25-0.03v-0.01C16.69,28.25,16.61,28.26,16.53,28.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.76,28.48c-0.19-0.07-0.37-0.12-0.56-0.16C18.38,28.36,18.57,28.41,18.76,28.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.84,12.98h-0.5c-0.28,0-0.5-0.22-0.5-0.5v4.65h1V12.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.21,12.98h-0.5v15.95c-0.01,0-0.01-0.01-0.02-0.01c0.26,0.16,0.52,0.34,0.78,0.55 c0.15,0.09,0.23,0.25,0.24,0.42v-17.4C20.71,12.76,20.49,12.98,20.21,12.98z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.84,
    y: 17.14,
    className: "st1",
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.34,12.98h0.5h4.87h0.5c0.28,0,0.5-0.22,0.5-0.5s-0.22-0.5-0.5-0.5v0.5h-5.87v-0.5 c-0.28,0-0.5,0.22-0.5,0.5S14.06,12.98,14.34,12.98z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "14.84,11.98 14.34,11.98 14.34,12.48 20.21,12.48 20.21,11.98 19.71,11.98  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.78,28.24v-9.28c0-0.28-0.22-0.5-0.5-0.5s-0.5,0.22-0.5,0.5v9.28C17.11,28.2,17.44,28.2,17.78,28.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.78,28.24v0.01c0.33-0.04,0.67-0.04,1,0v-0.01C17.44,28.2,17.11,28.2,16.78,28.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.28,37.1h15.49c0.28,0,0.5-0.22,0.5-0.5s-0.22-0.5-0.5-0.5H18.04l-0.31,0.7 C17.65,36.98,17.47,37.1,17.28,37.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.98,36.99c-0.06-0.05-0.12-0.11-0.16-0.18C16.86,36.88,16.92,36.94,16.98,36.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.28,37.1c-0.09,0-0.17-0.03-0.24-0.07C17.11,37.07,17.19,37.1,17.28,37.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.77,38.85H17.28c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5h15.49c0.28,0,0.5-0.22,0.5-0.5 S33.05,38.85,32.77,38.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.59,41.6H17.28c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5h12.32c0.28,0,0.5-0.22,0.5-0.5 S29.87,41.6,29.59,41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.59,30.07c-0.07-0.05-0.13-0.1-0.2-0.15c-0.09-0.06-0.17-0.11-0.26-0.17c-0.13-0.08-0.25-0.14-0.38-0.2 c-0.08-0.04-0.16-0.08-0.24-0.11c-0.14-0.06-0.28-0.1-0.42-0.13c-0.07-0.02-0.13-0.04-0.2-0.05c-0.21-0.04-0.41-0.06-0.62-0.06 c0,0-0.01,0-0.01,0c-0.2,0-0.4,0.02-0.6,0.06c-0.07,0.01-0.14,0.04-0.21,0.06c-0.14,0.04-0.27,0.07-0.41,0.13 c-0.08,0.03-0.17,0.08-0.25,0.11c-0.13,0.06-0.25,0.12-0.38,0.19c-0.09,0.05-0.17,0.11-0.26,0.17c-0.07,0.04-0.13,0.1-0.2,0.14 l2.32,5.28L19.59,30.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.95,30.06l0.01,0.01c0.07-0.05,0.13-0.1,0.2-0.14C15.09,29.97,15.02,30.01,14.95,30.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.75,29.56c0.13,0.06,0.25,0.12,0.38,0.2C19.01,29.69,18.88,29.62,18.75,29.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.42,29.76c0.13-0.07,0.25-0.14,0.38-0.19C15.67,29.63,15.54,29.69,15.42,29.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.04,29.45c0.14-0.05,0.27-0.09,0.41-0.13C16.31,29.36,16.18,29.4,16.04,29.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.66,29.27c0.2-0.04,0.4-0.06,0.6-0.06C17.06,29.2,16.86,29.23,16.66,29.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.09,29.32c0.14,0.04,0.28,0.08,0.42,0.13C18.37,29.4,18.23,29.36,18.09,29.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.28,29.2c0.21,0,0.41,0.02,0.62,0.06C17.69,29.23,17.48,29.2,17.28,29.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.6,30.06c-0.07-0.05-0.14-0.09-0.21-0.13c0.07,0.04,0.13,0.1,0.2,0.15L19.6,30.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.77,28.49c-0.07,0.02-0.13,0.05-0.2,0.07C15.64,28.54,15.7,28.52,15.77,28.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.53,28.28c-0.07,0.01-0.13,0.03-0.2,0.04C16.4,28.31,16.46,28.29,16.53,28.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.08,36.14l-2.54-5.8c-0.13,0.06-0.27,0.08-0.41,0.01c-0.17-0.08-0.29-0.26-0.29-0.45 c0,0.08,0.02,0.16,0.06,0.23l2.92,6.67c0,0,0.01,0.01,0.01,0.01c-0.03-0.06-0.05-0.13-0.05-0.21 C16.78,36.39,16.9,36.22,17.08,36.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.03,37.03C17.01,37.02,17,37,16.98,36.99C17,37,17.01,37.02,17.03,37.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.42,30.36c-0.07,0.03-0.14,0.05-0.21,0.05c-0.07,0-0.13-0.02-0.2-0.04L17.5,36.1h0.55l2.63-6 c0.03-0.07,0.04-0.14,0.04-0.21v0.02C20.71,30.1,20.6,30.27,20.42,30.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.96,28.56c-0.07-0.03-0.14-0.05-0.21-0.08C18.82,28.51,18.89,28.53,18.96,28.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.69,28.92c-0.02-0.01-0.04-0.02-0.07-0.03C19.65,28.9,19.67,28.91,19.69,28.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.19,28.32c-0.06-0.01-0.13-0.03-0.19-0.04C18.07,28.29,18.13,28.3,18.19,28.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.47,29.47c-0.26-0.21-0.52-0.39-0.78-0.55c-0.02-0.01-0.04-0.02-0.07-0.03c-0.22-0.13-0.44-0.24-0.66-0.33 c-0.07-0.03-0.14-0.05-0.21-0.08c-0.19-0.07-0.37-0.12-0.56-0.16c-0.06-0.01-0.13-0.03-0.19-0.04c-0.08-0.01-0.15-0.01-0.23-0.02 v0.44c0,0.02-0.01,0.03-0.01,0.05c0.82,0.11,1.63,0.49,2.44,1.16l0,0l-0.2,0.46c0.06,0.03,0.13,0.04,0.2,0.04 c0.07,0,0.15-0.02,0.21-0.05c0.18-0.08,0.29-0.26,0.29-0.45v-0.02C20.7,29.72,20.62,29.56,20.47,29.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.12,30.36c0.13,0.06,0.28,0.04,0.41-0.01l-0.19-0.44c0,0,0,0,0,0l0,0l0,0c0.82-0.67,1.63-1.04,2.45-1.16 c0-0.02-0.01-0.03-0.01-0.05v-0.44c-0.08,0.01-0.17,0.01-0.25,0.03c-0.07,0.01-0.13,0.03-0.2,0.04c-0.19,0.04-0.37,0.1-0.56,0.17 c-0.07,0.02-0.13,0.05-0.2,0.07c-0.51,0.21-1.02,0.52-1.52,0.93c-0.13,0.09-0.21,0.24-0.21,0.41 C13.84,30.1,13.95,30.27,14.12,30.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.78,28.25v0.44c0,0.02,0.01,0.03,0.01,0.05c0.33-0.04,0.65-0.04,0.98,0c0-0.02,0.01-0.03,0.01-0.05v-0.44 C17.44,28.21,17.11,28.21,16.78,28.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.28,36.6l-0.2-0.46c-0.18,0.08-0.3,0.25-0.3,0.46c0,0.08,0.02,0.15,0.05,0.21 c0.04,0.08,0.09,0.13,0.16,0.18c0.02,0.01,0.03,0.02,0.05,0.03c0.07,0.04,0.16,0.07,0.24,0.07c0.2,0,0.38-0.12,0.46-0.3l0.31-0.7 H17.5L17.28,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.16,29.93c0.09-0.06,0.17-0.12,0.26-0.17C15.33,29.81,15.25,29.87,15.16,29.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.26,29.2c0,0,0.01,0,0.01,0C17.27,29.2,17.27,29.2,17.26,29.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.59,30.07l-2.32,5.28l-2.32-5.28c-0.1,0.07-0.2,0.14-0.3,0.22c-0.04,0.03-0.08,0.03-0.12,0.05l2.54,5.8 c0.06-0.03,0.13-0.04,0.2-0.04h0.22l2.52-5.74c-0.04-0.02-0.09-0.04-0.12-0.07C19.79,30.21,19.69,30.15,19.59,30.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.9,29.27c0.07,0.01,0.13,0.04,0.2,0.05C18.03,29.3,17.96,29.28,17.9,29.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.79,29.57c0.08-0.04,0.17-0.08,0.25-0.11C15.96,29.48,15.88,29.53,15.79,29.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.13,29.76c0.09,0.05,0.17,0.11,0.26,0.17C19.31,29.87,19.22,29.81,19.13,29.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.45,29.32c0.07-0.02,0.14-0.04,0.21-0.06C16.59,29.28,16.52,29.31,16.45,29.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.51,29.45c0.08,0.03,0.16,0.07,0.24,0.11C18.67,29.53,18.59,29.48,18.51,29.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.28,29.2c-0.26,0-0.46-0.2-0.49-0.45c-0.82,0.11-1.63,0.49-2.45,1.16l0.19,0.44 c0.04-0.02,0.09-0.02,0.12-0.05c0.1-0.08,0.2-0.15,0.3-0.22l-0.01-0.01c0.07-0.05,0.14-0.09,0.21-0.13 c0.09-0.06,0.17-0.12,0.26-0.17c0.13-0.07,0.25-0.14,0.38-0.19c0.08-0.04,0.17-0.08,0.25-0.11c0.14-0.05,0.27-0.09,0.41-0.13 c0.07-0.02,0.14-0.04,0.21-0.06c0.2-0.04,0.4-0.06,0.6-0.06C17.27,29.2,17.27,29.2,17.28,29.2c0.21,0.01,0.41,0.03,0.62,0.07 c0.07,0.01,0.13,0.04,0.2,0.05c0.14,0.04,0.28,0.08,0.42,0.13c0.08,0.03,0.16,0.07,0.24,0.11c0.13,0.06,0.25,0.12,0.38,0.2 c0.09,0.05,0.17,0.11,0.26,0.17c0.07,0.05,0.14,0.08,0.21,0.13l-0.01,0.01c0.1,0.07,0.2,0.13,0.3,0.22 c0.04,0.03,0.08,0.05,0.12,0.07l0.2-0.46l0,0c-0.81-0.67-1.63-1.05-2.44-1.16C17.74,29,17.53,29.2,17.28,29.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "14.34,29.9 14.34,29.9 14.34,29.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.79,28.75c0.03,0.25,0.23,0.45,0.49,0.45s0.46-0.2,0.49-0.45C17.44,28.7,17.11,28.7,16.79,28.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.08,36.14l0.2,0.46l0.22-0.5h-0.22C17.2,36.1,17.14,36.11,17.08,36.14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansAndPermits);
export default __webpack_public_path__ + "static/media/plans-and-permits.39d427bee72598cf0dfdfe5cbea50123.svg";
export { ForwardRef as ReactComponent };